/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Copy_Aria_LabelInputs */

const en_copy_aria_label = /** @type {(inputs: Copy_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy selected events or text`)
};

const fr_copy_aria_label = /** @type {(inputs: Copy_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copier les evenements ou le texte selectionnes`)
};

const de_copy_aria_label = /** @type {(inputs: Copy_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ausgewählte Ereignisse oder Text kopieren`)
};

const it_copy_aria_label = /** @type {(inputs: Copy_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copia gli eventi o il testo selezionati`)
};

const ru_copy_aria_label = /** @type {(inputs: Copy_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Скопировать выбранные события или текст`)
};

const es_copy_aria_label = /** @type {(inputs: Copy_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiar eventos o texto seleccionados`)
};

const zh_cn2_copy_aria_label = /** @type {(inputs: Copy_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`复制选定的事件或文本`)
};

const ja_copy_aria_label = /** @type {(inputs: Copy_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選択したイベントまたはテキストをコピーする`)
};

const hi_copy_aria_label = /** @type {(inputs: Copy_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`चयनित घटनाओं या पाठ को कॉपी करें`)
};

const pt_pt2_copy_aria_label = /** @type {(inputs: Copy_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiar eventos ou texto selecionados`)
};

/**
* | output |
* | --- |
* | "Copy selected events or text" |
*
* @param {Copy_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const copy_aria_label = /** @type {((inputs?: Copy_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Copy_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_copy_aria_label(inputs)
	if (locale === "de") return de_copy_aria_label(inputs)
	if (locale === "it") return it_copy_aria_label(inputs)
	if (locale === "ru") return ru_copy_aria_label(inputs)
	if (locale === "es") return es_copy_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_copy_aria_label(inputs)
	if (locale === "ja") return ja_copy_aria_label(inputs)
	if (locale === "hi") return hi_copy_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_copy_aria_label(inputs)
	return en_copy_aria_label(inputs)
});